import { trendFetch } from 'api';
import { trackInitiateCheckout } from 'services/analytics';
import { Brand } from 'types/brand';
import { StripeCheckoutSession, StripePackage } from 'types/payment';

export const getPackages = async (): Promise<StripePackage[]> => {
  return trendFetch('/payment/stripe/packages').then((res) => res.json());
};

export const postProductCheckout = (productId: string, brand: Brand) => {
  const cancelUrl = window.location.href;
  return trendFetch(`/payment/stripe/checkout/${productId}`, {
    method: 'POST',
    body: JSON.stringify({ cancelUrl }),
  })
    .then((res) => res.json())
    .then(async (checkoutSession: StripeCheckoutSession) => {
      trackInitiateCheckout(brand, checkoutSession);
      return checkoutSession.url!;
    });
};
